import React from 'react';
import { faCarBump } from '@fortawesome/pro-regular-svg-icons/faCarBump';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface CarBumpRegularIconProps {
  className?: string;
}

function CarBumpRegularIcon(props: CarBumpRegularIconProps) {
  return <FontAwesomeIcon icon={faCarBump} {...props} />;
}

export default CarBumpRegularIcon;
